
//userData.js
export default {
    state: {
      userDetails: [
        { id: 1, username: 'A7653498', email: 'ram@gmail.com', state: 'Telangana', name: 'ram', mobile: '7688743654', WalletBalance: '10000', status: 'active',address:'7-11,Main Road,Amalapuram',city:'Kakinada',pinCode:'533216',panNumber:'HGA786233T',aadhaarNumber:'873472686234',businessName:'Aqua',contactNumber:'7865346654',businessAddress:'Amalapuram',gst:'yes', gstNumber:'GTDT7685',role: 'admin' },
        { id: 2, username: 'A7653400', email: 'Virat@gmail.com', state: 'Delhi', name: 'virat', mobile: '7688743054', WalletBalance: '10000', status: 'active',address:'107-11,Main Road,Madhapur',city:'hyderabad',pinCode:'500081',panNumber:'GTFR6233T',aadhaarNumber:'873472686234',businessName:'Aqua',contactNumber:'9865346654',businessAddress:'Hyderabad',gst:'yes',gstNumber:'GTDT7685', role: 'distributor' },
        { id: 3,  username: 'A7653450', email: 'John@gmail.com', state: 'Karnataka', name: 'john', mobile: '7688743443', WalletBalance: '15000', status: 'active',address:'7-11,Main Road,Amalapuram',city:'Kakinada',pinCode:'50001',panNumber:'FLQu786233T',aadhaarNumber:'993472686234',businessName:'Construction',contactNumber:'7065346654',businessAddress:'hyderabad',gst:'yes',gstNumber:'GTDT7685', role: 'distributor' },
        { id: 4, username: 'A7653451', email: 'admin@gmail.com', state: 'Tamil Nadu', name: 'admin', mobile: '7688743455', WalletBalance: '20000', status: 'inactive', role: 'admin' },
        { id: 5,  username: 'A7653451', email: 'admin@gmail.com', state: 'Tamil Nadu', name: 'reatiler', mobile: '7688743455', WalletBalance: '20000', status: 'active',address:'90-9213-1,Main Road,hyderabad',city:'hyderabad',pinCode:'533216',panNumber:'LKU3246233T',aadhaarNumber:'873472686234',businessName:'Aqua',contactNumber:'7865146654',businessAddress:'hyderabad',gst:'yes',gstNumber:'GTDT7685', role: 'retailer' }
      ],
      lastUserId: 5
    },
    getters: {
      getUserDetailsByRole: (state) => (role) => {
        return state.userDetails.filter(user => {
          return (role ? user.role === role : true) && user.status === 'active';
        });
      },
      totalRecords: (state) => state.userDetails.length
    },
    mutations: {
      USER_DETAILS(state, newuser) {
        newuser.id = state.lastUserId + 1;
        state.userDetails.push(newuser);
        state.lastUserId = newuser.id;
      },
      
      UPDATE_USER(state, updatedUser) {
        const index = state.userDetails.findIndex(user => user.id === updatedUser.id);
        if (index !== -1) {
          state.userDetails[index]= updatedUser; 
        }
      },
      
      DELETE_USER_DETAILS(state, userId) {
        state.userDetails = state.userDetails.filter(user => user.id !== userId);
      } 
    },
    
    actions: {
      addUserDetails({ commit }, newuser) {
        commit('USER_DETAILS', newuser);
      },
      
      // Action to update a user’s details
      updateUserDetails({ commit }, updatedUser) {
        commit('UPDATE_USER', updatedUser);
      },
      
      deleteUserDetails({ commit }, userId) {
        commit('DELETE_USER_DETAILS', userId);
      }
    }
    
  };
  